const moment = require("moment");

moment.locale("id");

module.exports = {
  generateYears: (startYear, year) => {
    const years = [];
    let valueYear = "";
    let startYearTemp = startYear || 1980;
    while (startYearTemp <= year) {
      startYearTemp += 1;
      valueYear = startYearTemp;
      years.push({
        text: valueYear,
        value: valueYear,
      });
    }
    return years;
  },
  generateMonths: () => {
    const months = [];
    let bulan = "";

    moment.locale("id");
    for (let i = 1; i <= 12; i += 1) {
      bulan = moment(i, "M").format("MMMM");
      months.push({
        text: bulan,
        value: i,
      });
    }

    return months;
  },
  startYear: 2020,
  defaultYear: moment().add(1, "years").format("YYYY"),
  intThousand: (value) => {
    let hasil = value;

    if (hasil != "" && typeof hasil !== "undefined") {
      hasil = hasil.toString().replace(/\./g, "");
      hasil = hasil.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    return hasil;
  },
  setInputIntOnly: (evt) => {
    const ASCIICode = evt.which ? evt.which : evt.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) {
      evt.preventDefault();
    }
  },
  showError: (g, err, title) => {
    let showError;
    if (err.response) showError = err.response.data;
    else if (err.request) showError = err.request;
    else showError = `Error ${err.message}`;

    g.$bvToast.toast(showError || "Something Wrong", {
      title,
      variant: "danger",
      solid: true,
    });
  },
  showNotifikasi: (g, type, title, pesan) => {
    g.$bvToast.toast(pesan, {
      title,
      variant: type,
      solid: true,
    });
  },
  requiredMessage: "tidak boleh kosong",
  checkField: (val, compareWith) => {
    if (!val && compareWith) return false;

    return true;
  },
  defaultValue: { text: "-- Pilih Salah Satu --", value: null },
  validateState: (item) => {
    const { $error } = item;
    let result = null;
    if ($error) result = false;
    return result;
  },
  tahunNow: moment().format("YYYY"),
  validateState2: (item) => {
    const { $error } = item;
    return $error ? false : null;
  },
  parserValue: (fname, value) => {
    let toReturn = "";
    switch (fname) {
      case "dateOnly":
        if (value) toReturn = moment(value).format("LL");
        else toReturn = "-";
        break;
      case "dateTime":
        if (value) toReturn = moment(value).format("LLLL");
        else toReturn = "-";
        break;
      default:
        toReturn = value;
    }
    return toReturn;
  },

  closeSistemKibB() {
    const moment = require("moment");
    moment.locale("id");
    // const tg = moment("2025-01-31 23:59:59");
    const tg = null; // di null kan karena belum tau kapan di tutup
    let response = {
      isOpen: false,
      targetClose: tg
        ? tg.format("dddd, DD MMMM YYYY [pukul] HH:mm:ss [WIB]")
        : null,
    };
    if (tg == null || tg.isAfter()) {
      response.isOpen = true;
    }

    return response;
  },
};
